
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Mail, Phone, MessageSquare } from "lucide-react";

const ContactUs = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow container mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-6 text-center">Contact Us</h1>
          
          <p className="text-gray-600 mb-8 text-center">
            We value your feedback and are committed to providing the best possible service. 
            If you have any questions, concerns, or need assistance, feel free to reach out to us:
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center">
              <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center mb-4">
                <Mail className="h-6 w-6 text-brand-blue" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Email</h3>
              <p className="text-gray-600 mb-3">
                For all inquiries and support
              </p>
              <a 
                href="mailto:careerguidekerala@gmail.com" 
                className="text-brand-blue hover:underline font-medium"
              >
                careerguidekerala@gmail.com
              </a>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center">
              <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center mb-4">
                <Phone className="h-6 w-6 text-brand-blue" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Phone</h3>
              <p className="text-gray-600 mb-3">
                Monday to Friday, 9:00 AM – 6:00 PM
              </p>
              <a 
                href="tel:+917909111007" 
                className="text-brand-blue hover:underline font-medium"
              >
                +91 7909111007
              </a>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center">
              <div className="w-12 h-12 rounded-full bg-brand-blue/10 flex items-center justify-center mb-4">
                <MessageSquare className="h-6 w-6 text-brand-blue" />
              </div>
              <h3 className="font-semibold text-lg mb-2">Live Chat</h3>
              <p className="text-gray-600 mb-3">
                Available on the website during business hours
              </p>
              <span className="text-brand-blue font-medium">Chat with us</span>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-sm">
            <h2 className="text-2xl font-semibold text-gray-900 mb-6">Send Us a Message</h2>
            
            <form className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-brand-blue focus:border-brand-blue"
                    placeholder="John Doe"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-brand-blue focus:border-brand-blue"
                    placeholder="john@example.com"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-brand-blue focus:border-brand-blue"
                  placeholder="How can we help you?"
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-brand-blue focus:border-brand-blue"
                  placeholder="Your message here..."
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="bg-brand-blue text-white px-6 py-2 rounded-md hover:bg-brand-blue/90 transition-colors"
              >
                Send Message
              </button>
            </form>
          </div>
          
          <div className="mt-12 text-center">
            <p className="text-gray-600">
              We aim to respond to all inquiries within 24 hours.
              <br />
              Thank you for choosing CareerGuideKerala.in for your career guidance needs.
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ContactUs;
